export const REQUITED_MESSAGE = 'Camp obligatoriu';
export const INVALID_EMAIL_ADDRESS = 'Adresa de e-mail invalida';
export const INVALID_PHONE_NUMBER = "Numar telefon invalid";
export const MIN_LENGTH_IS = 'Lungimea minima este ';
export const INVALID_COGNITO_PASSWORD_FORMAT = 'Minimul 8 caractere; litere mici, litere mari, numere si caractere speciale';
export const PWD_AND_PWD_CONF_MISMATCH = '"Parola" si "Confirmare Parola" nu sunt identice';

export const INVALID_USER_OR_PASSWORD = "Utilizatorul sau parola nu se potrivesc";
export const INACTIVE_USER = "Utilizator inactiv!";

export const INVALID_INTEGER = "Campul trebuie sa contina un numar intreg";

export const TASK_MIN_SELECTED_EMPLOYEES = 'Trebuie selectat minim un angajat';
export const TASK_MAX_SELECTED_EMPLOYEES = 'Numarul maxim de angajati selectati este 90!';

export const DATE_FORMAT_INVALID = 'Format data este invalid';